// @flow

import React, { useState, useEffect } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import dompurify from 'dompurify';

import type { RootState, ContentState } from '../../../store/types';
import { GET_CONTENT } from '../../../store/actions';

type HtmlContentContainerRawProps = {
  className: string,
  contentKey: string,
};

const HtmlContentContainerRaw = ({ className, contentKey }: HtmlContentContainerRawProps) => {
  const sanitizer = dompurify.sanitize;
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const contentObj: ContentState = useSelector((state: RootState) => state.content);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: GET_CONTENT,
      payload: contentKey,
    });
  }, [contentKey, dispatch]);

  useEffect(() => {
    const targettedContentObj = contentObj.contents.find((item) => item.key === contentKey);

    setContent(targettedContentObj ? targettedContentObj.content : '');
    setLoading(targettedContentObj ? targettedContentObj.loading : true);
  }, [contentKey, contentObj]);

  return (
    <>
      <div>{loading ? 'Loading' : ''}</div>
      <div className={className} dangerouslySetInnerHTML={{ __html: sanitizer(content) }} />
    </>
  );
};

export const HtmlContentContainer: StyledComponent<{}, {}, typeof HtmlContentContainerRaw> = styled(
  HtmlContentContainerRaw
)``;
